import PictureComponent from "components/core/picture/picture-component";
import { StyledTextAndProof } from "./careers-text-and-proof-component.scss";

export default function TextAndProof({ text, image }) {
  return (
    <StyledTextAndProof className="title-and-proof">
      <div className="text">{text}</div>
      <PictureComponent {...image} className="proof-badges-image" />
    </StyledTextAndProof>
  );
}
